import React, { useEffect, useState } from "react";
import { Coffee, Heart, ArrowUpRight } from "lucide-react";
import { getSettings } from "@/lib/api";

/**
 * TipJar — a soft "support this work" card for blog / writing posts.
 * Reads the tip URL from public settings (Admin → Social & Profile → Tip Jar URL).
 * Silently hides itself when no URL is configured.
 *
 * Common providers to paste: buymeacoffee.com/…, ko-fi.com/…, paypal.me/…,
 * stripe payment link, revolut.me/…, or your own /donate page.
 */
export default function TipJar({ className = "" }) {
  const [url, setUrl] = useState(null);
  const [label, setLabel] = useState("Buy me a coffee");

  useEffect(() => {
    getSettings().then((s) => {
      const tip = s?.social?.tipjar || s?.tipjar_url;
      if (tip) setUrl(tip);
      if (s?.tipjar_label) setLabel(s.tipjar_label);
    }).catch(() => {});
  }, []);

  if (!url) return null;

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer sponsored"
      data-testid="tip-jar"
      className={`group flex items-center gap-4 border border-primary/30 bg-gradient-to-br from-primary/5 to-transparent p-5 hover:border-primary transition-colors ${className}`}
    >
      <div className="w-12 h-12 grid place-items-center bg-primary text-primary-foreground rounded-full flex-shrink-0">
        <Coffee className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-mono text-[10px] uppercase tracking-widest text-primary flex items-center gap-1.5">
          <Heart className="w-3 h-3" /> Enjoyed this?
        </p>
        <p className="font-display text-xl mt-1">{label}</p>
        <p className="text-sm text-muted-foreground mt-0.5">A small tip keeps the writing free.</p>
      </div>
      <ArrowUpRight className="w-5 h-5 text-primary group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform flex-shrink-0" />
    </a>
  );
}
